<form [formGroup]="financialAccountForm">
  <rkt-form
    class="px-5 py-3 bg-gray-100"
    [form]="financialAccountForm"
    [fields]="financialAccountFields()"
    [model]="formModel"
    (modelChange)="onFinancialAccountDetailsChange()"
  />

  @if (showDebitAuthorization) {
    <div class="mt-4 flex items-center gap-2"><rkt-icon name="card" />Debit Authorization</div>
    <rkt-form
      class="px-5 py-3 linx-fa-debit-authorization-form bg-gray-100"
      [form]="debitAuthorizationForm"
      [fields]="debitAuthorizationField"
      [model]="formModel"
      (modelChange)="onFinancialAccountDetailsChange()"
    />
  }
</form>
